import { render, staticRenderFns } from "./TabMenu.vue?vue&type=template&id=139969b6&scoped=true"
import script from "./TabMenu.vue?vue&type=script&lang=js"
export * from "./TabMenu.vue?vue&type=script&lang=js"
import style0 from "./TabMenu.vue?vue&type=style&index=0&id=139969b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139969b6",
  null
  
)

export default component.exports